import type { OptionComponent } from 'shared/src/api';
import { useCallback, useContext, useEffect, useState } from 'react';
import { bridge, isNotNil } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { usePostGoodsActionMode } from '../../PostGoodsActionBottomSheet/context/PostGoodsActionContext';
import { useSelectOptionContext } from '../context/SelectOptionsContext';
import { GoodsParamsContext } from '../../../context/GoodsParamsContext';

export const useLogViewLastDepthGoodsOptionModal = (params: {
  isFinalDepth: boolean;
  options: OptionComponent[];
}) => {
  const [isLogged, setIsLogged] = useState(false);
  const goodsSno = useGoodsSno();
  const mode = usePostGoodsActionMode();
  const { mode: selectOptionMode } = useSelectOptionContext();
  const injected = useContext(GoodsParamsContext);

  const calculateDelayPercent = useCallback(() => {
    const delayedOptions = params.options.filter(
      option => option.goods_option?.is_delayed,
    );
    const delayedCount = delayedOptions.length;
    const totalCount = params.options.length;

    if (delayedCount === 0 || totalCount === 0) return 0;

    const delayPercent = (delayedCount / totalCount) * 100;
    const ceiledPercent = Math.ceil(delayPercent);

    return ceiledPercent > 100 ? 100 : ceiledPercent;
  }, [params.options]);

  useEffect(() => {
    if (!params.isFinalDepth) {
      return;
    }
    if (isLogged) return;

    bridge.logAnalyticsEvent({
      name: 'VIEW_LAST_DEPTH_GOODS_OPTION_MODAL',
      analytics: {
        EVENT_TYPE: 'VIEW_LAST_DEPTH_GOODS_OPTION_MODAL',
        GOODS_SNO: goodsSno.toString(),
        OPTION_COUNT: params.options.length,
        SCREEN: injected?.logging ? injected.logging.screen : 'GOODS_DETAIL',
        DELIVERY_DATE_INFO:
          params.options.filter(option => isNotNil(option.delivery_lead_days))
            .length > 0
            ? '1'
            : '0',
        IS_SOLDOUT_AT_LEAST_ONE:
          params.options.filter(option => option.goods_option?.is_soldout)
            .length > 0
            ? '1'
            : '0',
        IS_DELAY_PERCENT: calculateDelayPercent(),
        ...(selectOptionMode === 'gift' ? { KIND: 'GIFT' } : {}),
      },
    });
    setIsLogged(true);
  }, [
    calculateDelayPercent,
    goodsSno,
    injected,
    isLogged,
    mode,
    params.isFinalDepth,
    params.options,
    params.options.length,
    selectOptionMode,
  ]);
};
